var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineOperatorAddreasonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12C2.5 6.76614 6.76614 2.5 12 2.5C17.2339 2.5 21.5 6.76614 21.5 12C21.5 17.2339 17.2339 21.5 12 21.5C6.76614 21.5 2.5 17.2339 2.5 12ZM13.25 16V13.25H16C16.6861 13.25 17.25 12.6861 17.25 12C17.25 11.3139 16.6861 10.75 16 10.75H13.25V8C13.25 7.31386 12.6861 6.75 12 6.75C11.3139 6.75 10.75 7.31386 10.75 8V10.75H8C7.31386 10.75 6.75 11.3139 6.75 12C6.75 12.6861 7.31386 13.25 8 13.25H10.75V16C10.75 16.6861 11.3139 17.25 12 17.25C12.6861 17.25 13.25 16.6861 13.25 16Z",
    fill: "#1E6EFE",
    stroke: "#1E6EFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineOperatorAddreasonicon);
export default __webpack_public_path__ + "static/media/Line Operator - Add reason icon.d1d3c7322cecfb7307bf10e1916d46f7.svg";
export { ForwardRef as ReactComponent };